import { memo, useCallback } from "react";

import EditWishlistNamePopup from "~/features/wishlist/components/modals/EditWishlistNamePopup";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { LinkButton } from "~/common/components/Link";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { type WishlistModel } from "~/features/wishlist/types/model";
import { renameWishlistThunk } from "~/features/wishlist/redux/wishlistSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

interface RenameWishlistButtonProps {
  wishlist: WishlistModel;
}

const RenameWishlistButton = ({ wishlist }: RenameWishlistButtonProps) => {
  const { setTrue: openPopup, setFalse: closePopup, val: isModalOpen } = useBooleanState(false);

  const dispatch = useDispatch();
  const confirm = useCallback(
    (newName: string) => {
      closePopup();
      dispatch(renameWishlistThunk(wishlist.id, newName));
    },
    [closePopup],
  );

  const { t } = useTranslation();

  return (
    <>
      <LinkButton onClick={openPopup} data-test-id={"btn-rename-wishlist"} iconBefore={<Icon type={IconType.Pencil} />}>
        {t("page.wishlist.action.rename")}
      </LinkButton>
      {isModalOpen && (
        <EditWishlistNamePopup onCancel={closePopup} onOk={confirm} initialWishlistName={wishlist.name} />
      )}
    </>
  );
};

export default memo(RenameWishlistButton);
